import { isApiError, type AiContentDetailResponse, type AiContentPatch } from '@shared/api';
export type AiContentDraft = { title: string; content: string; type: string };
export const toDraft = (detail: AiContentDetailResponse): AiContentDraft => ({
  title: detail.data.title ?? '',
  content: detail.data.content ?? '',
  type: detail.data.type ?? '',
});
export function changedFields(draft: AiContentDraft, base: AiContentDraft): AiContentPatch {
  return {
    ...(draft.title !== base.title ? { title: draft.title.trim() } : {}),
    ...(draft.content !== base.content ? { content: draft.content } : {}),
    ...(draft.type !== base.type ? { type: draft.type || null } : {}),
  };
}
export function outcomeUnknown(error: unknown) {
  return (
    !isApiError(error) ||
    error.status === 0 ||
    error.status >= 500 ||
    (error.status >= 200 &&
      error.status < 300 &&
      ['PARSE_ERROR', 'VALIDATION_ERROR'].includes(error.code))
  );
}
export function errorKey(error: unknown) {
  if (!isApiError(error)) return 'aiContent.errors.failed';
  if (error.code === 'AI_CONTENT_READ_ONLY') return 'aiContent.errors.readOnly';
  if (error.code === 'AI_CONTENT_IMMUTABLE_REVISION') return 'aiContent.errors.readOnly';
  if (error.code === 'AI_CONTENT_DELETE_PENDING') return 'aiContent.deletion.pending';
  switch (error.status) {
    case 401:
      return 'aiContent.errors.signedOut';
    case 403:
      return 'aiContent.errors.denied';
    case 404:
      return 'aiContent.errors.notFound';
    case 409:
      return 'aiContent.errors.conflict';
    case 412:
      return 'aiContent.errors.stale';
    case 428:
      return 'aiContent.errors.validator';
    case 400:
      return 'aiContent.errors.invalid';
    default:
      return 'aiContent.errors.failed';
  }
}
